import React from 'react'

import { Block } from 'elements/layout/Block'
import { Cell } from 'elements/layout/Cell'
import { Div } from 'elements/layout/Div'
import { PreloadDiv } from 'elements/layout/PreloadDiv'
import { RoundDiv } from 'elements/layout/RoundDiv'
import { Row } from 'elements/layout/Row'
import { Space } from 'elements/layout/Space'

type TPreloadIntentionItemProps = {
  withWrapper?: boolean
  widgetId: number
}

export const PreloadIntentionItem: TFC<TPreloadIntentionItemProps> = ({ withWrapper, widgetId }) => (
  <Div p="10px" as={withWrapper ? Block : undefined}>
    <Row nowrap gutter="10px">
      {!widgetId && (
        // on Hozana site
        <Cell minW="50px">
          <PreloadDiv as={RoundDiv} size="40px" />
        </Cell>
      )}
      <Cell flex="1" m="0 30px 0 0">
        <PreloadDiv h="1em" w="100%" m="0 0 10px" />
        <PreloadDiv h="1em" w="100%" m="0 0 10px" />
        <PreloadDiv h="1em" w="50%" m="0 0 10px" />
      </Cell>
    </Row>
    <Space h="5px" />
    <Row>
      <Cell flex="1" m="auto 0">
        <PreloadDiv w="40px" h="20px" />
      </Cell>
      {/* button iPray */}
      <Cell>
        <PreloadDiv w="60px" h="30px" />
      </Cell>
    </Row>
  </Div>
)
